import { request } from './api';
import axios from 'axios';

/** 接口返回的原始预置问题项 */
export interface PromptItem {
    prompt_id: string;
    prompt: string;
    description: string;
    content: string;
    category: 'capability' | 'suggestion';
}

/** 展示用的预置问题项（含视觉属性） */
export interface PresetPromptItem {
    prompt_id: string;
    title: string;
    desc: string;
    icon: string;
    color: string;
    bg: string;
}

/** 弗拉格预置问题列表接口响应 */
export interface PresetPromptsResponse {
    code: number;
    message: string;
    data: PromptItem[];
}

/** 获取弗拉格预置问题列表 */
export const getPresetPromptsApi = (): Promise<PresetPromptsResponse> => {
    return request({
        method: 'get',
        url: '/assistant/prompts',
    }).then(res => res);
};

interface ReactionParams {
    messageId: string;
    operator: string;
    sessionId: string;
}

const requestHeaders = { headers: { 'x-app-code': 'flagos' } };
const VITE_SOULCLAW_BASE_URL = import.meta.env.VITE_SOULCLAW_BASE_URL || '';

/** 点赞 */
export const likeMessageApi = (params: ReactionParams) => {
    return axios.post(VITE_SOULCLAW_BASE_URL + '/soulclawIm/api/v1/message-reactions/command/like', params, requestHeaders);
};

/** 取消点赞 */
export const unlikeMessageApi = (params: ReactionParams) => {
    return axios.post(VITE_SOULCLAW_BASE_URL + '/soulclawIm/api/v1/message-reactions/command/unlike', params, requestHeaders);
};

/** 点踩 */
export const dislikeMessageApi = (params: ReactionParams) => {
    return axios.post(VITE_SOULCLAW_BASE_URL + '/soulclawIm/api/v1/message-reactions/command/dislike', params, requestHeaders);
};

/** 取消点踩 */
export const undislikeMessageApi = (params: ReactionParams) => {
    return axios.post(VITE_SOULCLAW_BASE_URL + '/soulclawIm/api/v1/message-reactions/command/undislike', params, requestHeaders);
};

/** 专家信息 */
export interface ExpertInfo {
    userId: string;
    instanceId: string;
    [key: string]: any;
}

/** 获取专家列表 */
export const discoverExpertsApi = (userId: string): Promise<{ code: number; data: { total: number; list: ExpertInfo[] } }> => {
    return axios.post(VITE_SOULCLAW_BASE_URL + '/expert/api/v1/c/discover', {
        pageNum: 1,
        pageSize: 6,
        userId,
    }, {
        ...requestHeaders,
        withCredentials: true,
    });
};
